exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/ras.universarium.org/www/src/app/learn-structure/learn-structure.component.scss
// module id = ../../../../../src/app/learn-structure/learn-structure.component.scss
// module chunks = 1